import { EditorDialog } from "./EditorDialog";
export class FormDialog extends EditorDialog {
    get isRefreshNeeded() {
        return this.anyChildNeedsRefresh;
    }
}
